import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Box, Button, Link, Paper, Typography } from '@mui/material';

export const InternalError = () => (
	<Box sx={{ display: 'flex', height: '100vh' }}>
		<Paper sx={{ m: 'auto', p: 3 }}>
			<Typography variant="h1">
				<FormattedMessage id="internalError.title" defaultMessage="Došlo k chybě" />
			</Typography>
			<Typography>
				<FormattedMessage
					id="internalError.text"
					defaultMessage="Něco se pokazilo na naší straně.{br}Kdyby chyba přetrvala, neváhejte se na nás obrátit na {email}"
					values={{
						br: <br />,
						email: <Link href="mailto:info@infigy.cz">info@infigy.cz</Link>,
					}}
				/>
			</Typography>
			<Button variant="contained" sx={{ mt: 2 }} href="/">
				<FormattedMessage id="internalError.back" defaultMessage="Zpět na úvodní stránku" />
			</Button>
		</Paper>
	</Box>
);
